import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {repeat} from 'lit/directives/repeat.js'
import {containerStyles, normalizeStyles, typographyStyles} from '@webs/components-library/theming';
import { Button } from './button';
import {Breadcrumb} from "@webs/components-library/breadcrumbs";
import {ifDefined} from 'lit-html/directives/if-defined.js';

@customElement('webs-header-base-alternative')
export class HeaderBaseAlternative extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`
    .m-header-base-alternative {
      padding: 3rem 0;
      position: relative;
    }

    .rich-text-container--intro ::slotted(*) {
        font-family: var(--font-family-alternative);
        font-weight: var(--font-weight-base);
      }

    .m-header-base-alternative ::slotted([slot="title"]) { font-weight: var(--font-weight-light) !important;}

    .m-header-base-alternative__visual {
      margin-bottom: 2rem;
    }

    .m-header-base-alternative__logos {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
     }

    .m-header-base-alternative__actions {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      margin: 1.6rem -.5rem 0;
    }
    .m-header-base-alternative__actions webs-button,
    .m-header-base-alternative__actions webs-link-arrow {
      margin: 0 .5rem .55rem;
    }

    @media only screen and (min-width: 768px){

      .m-header-base-alternative__visual { margin-bottom: 0; }
    }

    @media only screen and (min-width: 992px){
     .m-header-base-alternative { padding: 8rem 0 7rem; }
      .m-header-base-alternative ::slotted([slot="title"]) { margin-bottom: 1.6rem !important;}
      .m-header-base-alternative__visual picture { padding-bottom: 100%; }
    }

    @media only screen and (min-width: 1175px){
      .m-header-base-alternative__content .wrapper { padding-top: 3.75rem; }
    }
    `
  ];

  @property()
  id: string;

  @property({attribute: 'artwork-position'})
  artworkPosition: string;

  @property({type: Array})
  buttons: Button[]

  @property()
  breadcrumbs: Breadcrumb[];

  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}" class="m-header-base-alternative">
            <div class="container">
          <webs-grid-row reverse="sm">
            <webs-grid-column sm="6" md-offset="1" class="m-header-base-alternative__visual">
              <slot name="media"></slot>
              <div class="m-header-base-alternative__logos">
                <slot name="header-logo"></slot>
              </div>
            </webs-grid-column>
            <webs-grid-column sm="6" md="5" class="m-header-base-alternative__content">
              <div class="wrapper">
                ${this.breadcrumbs && this.breadcrumbs.length ? html`<webs-breadcrumbs items='${this.breadcrumbs}'></webs-breadcrumbs>` : '' }
                <h1 class="h2">${ this.title }</h1>
                <slot name="title"></slot>
                <slot name="description"></slot>
                ${this.buttons && this.buttons.length ? html`
                  <div class="m-header-base-alternative__actions">
                    ${repeat(this.buttons, (button, index) => html`
                        ${button.type == 'link' ? html`
                          <webs-link-arrow href="${ button.href }" text="${ button.title }" new-tab="${button.openInNewTab}"></webs-link-arrow>` :
      html `
                          <webs-button href="${button.href}" text="${button.title}"new-tab="${button.openInNewTab}"></webs-button>
                        `}
                      `
    )}
                  </div>
                ` : ''}
              </div>
            </webs-grid-column>
          </webs-grid-row>
        </div>
        </section>
    `
  }
}
